import { useNavigate } from "react-router-dom";

export function Header() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between w-full px-6 py-3 bg-primary-blue">
      <p
        onClick={() => navigate("/")}
        className="flex-1 text-base font-medium text-left text-white cursor-pointer sm:text-lg"
      >
        Isporuka odmah
      </p>
      <svg
        width="40"
        height="50"
        viewBox="0 0 40 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => navigate("/")}
        className="cursor-pointer"
      >
        <path
          d="M19.9995 10.9513L2.3575 24.0541L2.36027 23.9635C2.5384 18.1507 4.45311 12.7152 7.75108 8.65846C11.061 4.58755 15.411 2.34562 20.0001 2.34562C24.5891 2.34562 28.939 4.58755 32.2488 8.65846C35.5469 12.7152 37.4614 18.1507 37.6397 23.9635L37.6425 24.0541L37.5697 24.0001L19.9995 10.9513ZM20.0001 47.3595C14.2717 47.3595 8.90938 43.807 5.59029 37.8391L5.55082 37.7624L19.9995 27.0641L34.4503 37.7638L34.4126 37.8326C34.4129 37.8329 34.4131 37.833 34.4134 37.8333C31.0947 43.8052 25.7322 47.3595 20.0001 47.3595ZM3.68626 33.4545L3.66743 33.3964C3.00444 31.3442 2.80772 29.5463 2.80567 29.5284L2.80314 29.5034L2.82331 29.4884L19.9992 16.7703L37.1969 29.5034L37.1943 29.5284C37.1923 29.5463 36.9954 31.3443 36.3326 33.3964L36.3137 33.4545L36.2645 33.4181L36.2635 33.4205L19.9988 21.3413L3.68697 33.4563L3.68626 33.4545ZM20 1.14441e-05C8.97195 1.14441e-05 0 11.1488 0 24.8526C0 38.5563 8.97195 49.7051 20 49.7051C31.0281 49.7051 40 38.5563 40 24.8526C40 11.1488 31.0281 1.14441e-05 20 1.14441e-05Z"
          fill="white"
          fillOpacity="0.9"
        />
      </svg>
      <p
        onClick={() => navigate("/")}
        className="flex-1 text-base text-right text-white cursor-pointer sm:text-lg opacity-70"
      >
        Citroën
      </p>
    </div>
  );
}

export default Header;
